class promosSlder extends HTMLElement {
  constructor() {
    super();
    let promoSwiper = new Swiper('[data-promo-slider]', {
      slidesPerView: 1.14,
      spaceBetween: 20,
      slidesPerGroup: 1,
      loop: true,
      autoplay: {
        delay: 4000, 
        disableOnInteraction: false
      },
      speed: 1000,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 1,
          navigation: {
            nextEl: '.product-promos__button-next',
            prevEl: '.product-promos__button-prev',
          }
        }
      }
    });
  }
}
customElements.define('promos-slider', promosSlder);